type WarnFn = (message: string) => unknown;

interface EnforceLimitOptions {
  digitsOnly?: boolean;
  uppercase?: boolean;
}

const DEBOUNCE_MS = 2000;
const lastWarningAt = new Map<string, number>();

export function enforceLimit(
  raw: string,
  limit: number,
  label: string,
  showWarning: WarnFn,
  opts: EnforceLimitOptions = {},
): string {
  let value = raw ?? '';
  if (opts.digitsOnly) value = value.replace(/\D/g, '');
  if (opts.uppercase) value = value.toUpperCase();

  if (value.length > limit) {
    const now = Date.now();
    const last = lastWarningAt.get(label) ?? 0;
    if (now - last > DEBOUNCE_MS) {
      lastWarningAt.set(label, now);
      const unit = opts.digitsOnly ? 'digits' : 'characters';
      showWarning(`${label} can be at most ${limit} ${unit}`);
    }
    value = value.slice(0, limit);
  }

  return value;
}
